import '../scss/theme.scss';

import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import InertiaPlugin from 'gsap/InertiaPlugin';
import { medusa } from './medusa.js';

gsap.registerPlugin(Draggable, InertiaPlugin);

window.gsap = gsap;
window.Draggable = Draggable;

import { setup } from './animations/index.js';

function addEnterAnimations(container) {
  if (!container) return;
  const animatedElements = [...container.querySelectorAll('[data-animation]')];
  
  animatedElements.forEach((el) => {
    const { animation } = el.dataset;
    
    if (setup.has(animation)) {
      setup.get(animation)(el);
      medusa.observe('enter-inview', el);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  addEnterAnimations(document.body);
});